import { createInstance } from '@optimizely/react-sdk';

import { OPTIMIZELY_SDK_KEY } from '../envConfig';

// Initialize Optimizely client once - exported for direct access in hooks
export const optimizelyClient = createInstance({ sdkKey: OPTIMIZELY_SDK_KEY });
